import { makeSx } from '../../../theme/_utils'

export default makeSx({
    TagList: {
        display: 'flex',
        gap: '.5rem',
        flexWrap: 'wrap',
    },
})
